export default __webpack_public_path__ + "static/media/blockchain.7904d48b.svg";